import { INfcCardsState } from './nfcCardsContext';
import { NfcCardsActionsTypes, TNfcCardsAction } from './nfcCardsActions';

export const nfcCardsReducer = (state: INfcCardsState, action: TNfcCardsAction): INfcCardsState => {
	switch (action.type) {
		case NfcCardsActionsTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case NfcCardsActionsTypes.SET_INITIAL_NFC_CARDS:
			return {
				...state,
				initialNfcCards: action.payload.initialNfcCards,
				nfcCards: action.payload.nfcCards,
			};
		case NfcCardsActionsTypes.SET_NFC_CARDS:
			return {
				...state,
				nfcCards: action.payload.nfcCards,
			};
		case NfcCardsActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case NfcCardsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
